import React from 'react';
import Helmet from 'react-helmet';

export class Head extends React.Component {
  componentDidMount () {
    window.website = this.props.website;
    window.slides = this.props.website.slides;
  }

  render () {
    return (
      <Helmet>
        <title>{this.props.website.title}</title>
        <meta name="description" content={this.props.website.shareText} />
        <meta property="og:image" content={'https:' + this.props.website.shareImage.file.url} />
        <link rel="icon" type="image/png" href="/favicon.png" />
      </Helmet>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/head.js